import gql from 'graphql-tag';

export const GET_ATTACHMENTS = gql`
  query ($appointmentId: String) {
    appointment (appointmentId: $appointmentId) {
      attachments {
        metaDataId
        mimeType
        encoding
        name
        thumbnail
        downloadRoute
        size
        comment
        status
      }
    }
  }
`;
